import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ROLES } from '../constants/roles.constants';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): boolean {
    // Vérifier si l'utilisateur est connecté
    if (!this.authService.isLoggedIn()) {
      this.router.navigate(['/auth/login']);
      return false;
    }

    // Récupérer l'utilisateur connecté
    const currentUser = this.authService.getCurrentUser();
    
    // Vérifier si l'utilisateur a le rôle admin ou superadmin
    if (currentUser && (currentUser.role?.nom === ROLES.ADMIN || currentUser.role?.nom === ROLES.SUPERADMIN)) {
      return true;
    }

    // Rediriger vers le login si l'utilisateur n'est pas admin
    this.router.navigate(['/auth/login']);
    return false;
  }
} 